import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ApiService } from 'app/shared/constant/api-service/api.service';
import { API_ENDPOINTS } from 'app/core/constants/api-endpoints.constant';

@Injectable({
    providedIn: 'root',
})
export class CommonService {
    private refreshSource = new Subject<void>();
    constructor(private _apiService: ApiService) {}

    refresh$ = this.refreshSource.asObservable();

    triggerRefresh() {
        this.refreshSource.next();
    }

    getAgencyData(): Observable<any> {
        return this._apiService.get(API_ENDPOINTS.PARTNERS);
    }
}
